module.exports = __webpack_public_path__ + "static/media/fssaiIconDinein.cd28448b.svg";